module.exports = __webpack_public_path__ + "img/discussionWall.ed16b2a5.png";